import store from '@/core/redux/store';
import { onlyAlphanumericAndSpecialChars } from '../patterns/regex.pattern';
import ServiceIcon1 from '../../assets/images/services/service-icon-1.png';
import ServiceIcon2 from '../../assets/images/services/service-icon-2.png';
import ServiceIcon3 from '../../assets/images/services/service-icon-3.png';
import ServiceIcon4 from '../../assets/images/services/service-icon-4.png';
import ServiceIcon5 from '../../assets/images/services/service-icon-5.png';
import ServiceIcon6 from '../../assets/images/services/service-icon-6.png';
import ServiceIcon7 from '../../assets/images/services/service-icon-7.png';
import ServiceIcon8 from '../../assets/images/services/service-icon-8.png';
import ServiceIcon9 from '../../assets/images/services/service-icon-9.png';
import ServiceIcon10 from '../../assets/images/services/service-10.png';
import washFoldImg from '../../assets/images/wash-fold-bg.jpg';
import aboutIcon1 from '../../assets/images/about-section/about-icon-01.png';
import aboutIcon2 from '../../assets/images/about-section/about-icon-02.png';
import aboutIcon3 from '../../assets/images/about-section/about-icon-03.png';
import aboutIcon4 from '../../assets/images/about-section/about-icon-04.png';
import bannerImg from '../../assets/images/theme5/home_page_single_search.jpg';
import bannerImgTwo from '../../assets/images/heroimg.png';
import easyToImg from '../../assets/images/easy-to-img.png';
import iphone13 from '../../assets/images/iPhone13.png';
import { postData } from '@/services/api.service';
import {
  alterations,
  bannerSlider1,
  bannerSlider2,
  bannerSlider3,
  bannerSlider4,
  bannerSlider5,
  dryCleaning,
  heroimg,
  heroimg2,
  home_banner,
  home_page_single_search,
  howwe1,
  howwe2,
  howwe3,
  howwe4,
  iPhone11,
  just_clickaway,
  laundry,
  priorityicon1,
  priorityicon14,
  priorityicon15,
  priorityicon16,
  priorityicon17,
  priorityicon2,
  priorityicon3,
  priorityicon4,
  priorityicon5,
  priorityicon6,
  priorityicon7,
  priorityicon8,
  priorityicon9,
  priorityimg1,
  priorityimg2,
  priorityimg3,
  reviewBg,
  testimonialimg1,
  testimonialimg2,
  testimonialimg3,
  testimonialuser1,
  testimonialuser2,
  testimonialuser3,
  trustimg1,
  trustimg2,
  trustimg3,
  trustimg4,
} from '../imagepath';

export const formatDate = (isoString: string) => {
  if (isoString !== null) {
    const date = new Date(isoString);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    };
    const formattedDate = date.toLocaleDateString('en-GB', options);
    return formattedDate.replace(/(\d+) (\w+) (\d+)/, '$1 $2, $3');
    // Output: 17 Jan, 2025
  }
};

export const formatTime = (isoString: string): string => {
  const date = new Date(isoString);

  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

  return `${formattedHours}:${minutes} ${ampm}`;
};

export const onKeyDownAlphabetOnly = (event: any) => {
  const input = event.target.value;
  const reg = onlyAlphanumericAndSpecialChars;
  if (
    event.key === 'Backspace' ||
    event.key === 'Delete' ||
    event.key === 'ArrowLeft' ||
    event.key === 'ArrowRight' ||
    event.key === ' '
  ) {
    return;
  }

  if (event.key === '.' && input.includes('.')) {
    event.preventDefault();
    return;
  }

  if (!reg.test(event.key)) {
    event.preventDefault();
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
};

export const isLoggedIn = () => {
  const state = store.getState();
  const userDetails = state?.common?.userDetails || {};
  const authToken = localStorage.getItem('token');
  return typeof userDetails === 'object' &&
    Object.values(userDetails).length > 0 &&
    authToken
    ? true
    : false;
};

export const fetchCroppedImage = async (image: any) => {
  let payload: any = { img: image, type: 1 };

  if (image instanceof File) {
    const formData = new FormData();
    formData.append('img', image);
    formData.append('type', '2');
    payload = formData;
  }

  const response = await postData('image_compress', payload);
  if (response) {
    return response.data.data.file_path;
  } else return false;
};

export const theme_5 = {
  theme_1: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: '/assets/img/section/section1.png',
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: '/assets/img/section/section3.png',
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: '/assets/img/section/section4.png',
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: '/assets/img/section/section5.png',
        },
      ],
      header: {
        primary_color: 'ff0059',
        secondary_color: 'ffcb00',
        nav: {
          nav_bg_color: 'ffffff',
          menu_font_color: '2e3639',
          menu_font_color_active: '1b9db3',
          menu_font_color_hover: 'f07f1b',
          cart_section: {
            cart_bg_color: 'ffffff',
            cart_icon_bg_color: 'f07f1b',
            cart_value_color: '000000',
          },
          contact: {
            contact_is_enable: true,
            number: '+(123) 456-7890',
            contact_color: '2e3639',
          },
        },
        btn_group: {
          btn1: {
            text: 'Login / Register',
            btn_bg_color: 'ffffff',
            btn_color: '1b9db3',
            border_color: '1b9db3',
            btn1_is_enable: true,
          },
        },
      },
      section_1: {
        banner: home_banner,
        sub_heading_top: 'Professional Services When You Need Them',
        title: 'Quality Solutions for Your Needs',
        paragraph:
          'Our team of experts is ready to help with all your requirements, providing reliable and efficient service with your satisfaction as our top priority.',
        btn_group: {
          btn1: {
            text: 'Book now',
            placeholder: 'Enter your location',
            bg_color: '1b9db3',
            color: 'ffffff',
          },
        },
      },
      section_2: {
        title: 'Schedule Your Service At Your Convenience',
        btn_group: {
          btn1: {
            text: 'Schedule now',
            placeholder: 'Enter your details',
            bg_color: '1b9db3',
            color: 'ffffff',
          },
        },
      },
      section_3: {
        is_section_enable: true,
        banner: trustimg1,
        title: 'Trust Our Professionals',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          'We take pride in delivering exceptional service with attention to detail and commitment to quality that our customers can rely on.',
        sub_heading: 'Comprehensive solutions tailored to your needs',
        check_list: [
          {
            _id: 1,
            list: 'Professional assessment of your requirements',
          },
          {
            _id: 2,
            list: 'Customized solutions for your specific situation',
          },
          {
            _id: 3,
            list: 'Quality materials and equipment',
          },
          {
            _id: 4,
            list: 'Ongoing maintenance options',
          },
        ],
        btn_group: {
          btn1: {
            text: 'Learn More',
            bg_color: '#ffcb00',
            color: 'ffffff',
            is_enable: true,
          },
        },
      },
      section_4: {
        title: 'Your Satisfaction Is Our Priority',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        cards: [
          {
            heading: 'Convenient scheduling',
            icon: '/assets/img/icons/icon1.svg',
            image: '/assets/img/service1.jpg',
            paragraph: 'Flexible appointment times to fit your busy schedule.',
          },
          {
            heading: 'Professional standards',
            icon: '/assets/img/icons/icon2.svg',
            image: '/assets/img/service2.jpg',
            paragraph:
              'All our technicians are fully qualified and experienced.',
          },
          {
            heading: 'Clear communication',
            icon: '/assets/img/icons/icon3.svg',
            image: '/assets/img/service3.jpg',
            paragraph: 'We keep you informed throughout the entire process.',
          },
        ],
      },
      section_5: {
        is_section_enable: true,
        banner: '/assets/img/app_screenshot.png',
        title: 'Manage Everything From Your Phone',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          'Our mobile app makes it easy to book, manage, and track your services anytime, anywhere.',
        check_list: [
          {
            _id: 1,
            icons: '/assets/img/icons/users.svg',
            title: 'Happy Clients',
            count: '10000+',
          },
          {
            _id: 2,
            icons: '/assets/img/icons/download.svg',
            title: 'App Downloads',
            count: '25000+',
          },
          {
            _id: 3,
            icons: '/assets/img/icons/rating.svg',
            title: 'Customer Rating',
            count: '4.8',
          },
        ],
        mobile_link_section: {
          is_enable: true,
          android_link:
            'https://play.google.com/store/apps/details?id=com.example.serviceapp',
          ios_link: 'https://apps.apple.com/us/app/service-app/id1234567890',
        },
      },
      section_6: {
        heading: 'Save With Our Service Plans',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        card_1: {
          card_one_title: 'Basic Maintenance Plan',
          card_one_paragraph:
            'Regular check-ups and maintenance to keep everything running smoothly. Affordable monthly plans starting from $29.99.',
          card_one_image: '/assets/img/plan1.png',
        },
        card_2: {
          card_two_title: 'Premium Service Package',
          card_two_paragraph:
            'Comprehensive coverage with priority scheduling and discounts on all services. Perfect for busy professionals and families.',
          card_two_image: '/assets/img/plan2.png',
        },
      },
      section_7: {
        is_section_enable: true,
        title: 'Our Comprehensive Services',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: '/assets/img/service-icon1.png',
              card_title: 'Standard Services',
            },
            {
              _id: 2,
              icon: '/assets/img/service-icon2.png',
              card_title: 'Specialized Solutions',
            },
            {
              _id: 3,
              icon: '/assets/img/service-icon3.png',
              card_title: 'Emergency Support',
            },
            {
              _id: 4,
              icon: '/assets/img/service-icon4.png',
              card_title: 'Preventive Maintenance',
            },
          ],
        },
      },
      section_8: {
        title: 'What Our Clients Say',
        cards: [
          {
            profile: '/assets/img/client1.jpg',
            name: 'Alex Johnson',
            position: 'Homeowner',
            message:
              'The team was professional, punctual, and did an excellent job. I would definitely recommend their services to others.',
            backgroundImage: '/assets/img/testimonial-bg1.jpg',
          },
          {
            profile: '/assets/img/client2.jpg',
            name: 'Sarah Williams',
            position: 'Business Owner',
            message:
              'Reliable service with great attention to detail. They solved my problem quickly and efficiently.',
            backgroundImage: '/assets/img/testimonial-bg2.jpg',
          },
        ],
      },
      section_9: {
        is_section_enable: true,
        title: 'Frequently Asked Questions',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          "We've compiled answers to common questions about our services and processes.",
        banner: [
          {
            banner: '/assets/img/faq-banner.jpg',
          },
        ],
        card_heading: 'HAVE QUESTIONS? CALL US:',
        card_number: '+(123) 456-7890',
        card_buttontext: 'Contact Us',
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: 'What is your service guarantee policy?',
              isEnabled: true,
              collection_paragraph:
                "We stand behind our work with a comprehensive satisfaction guarantee. If you're not completely happy with our service, we'll make it right.",
            },
            {
              _id: 2,
              collection_title: 'Do you offer emergency services?',
              isEnabled: true,
              collection_paragraph:
                'Yes, we provide 24/7 emergency support for urgent situations.',
            },
          ],
        },
      },
      section_10: {
        title: 'Latest Updates',
        button: {
          text: 'View More',
          bg_color: '#ffcb00',
          color: 'ffffff',
          is_enable: true,
        },
      },
      footer: {
        bg_color: 'ffffff',
        section_heading_color: 'ffffff',
        section_paragraph_color: 'c2c2c2',
        mbl_number: '+1234567890',
        email_val: 'info@exampleservice.com',
        address_val: '123 Business Street, City - ST 12345',
        footer_section: {
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: 'facebook.com',
            },
            instagram: {
              is_enable: true,
              instagram_link: 'instagram.com',
            },
            whatsapp: {
              is_enable: true,
              whatsapp_link: 'whatsapp.com',
            },
          },
        },
      },
    },
  },
  theme_2: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: '/assets/section-two/section1.png',
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: '/assets/section-two/section2.png',
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: '/assets/section-two/section3.png',
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: '/assets/section-two/section4.png',
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: '/assets/section-two/section5.png',
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: '/assets/section-two/section6.png',
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: '/assets/section-two/section7.png',
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: '/assets/section-two/section8.png',
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: '/assets/section-two/section9.png',
        },
      ],
      header: {
        primary_color: 'ff0059',
        secondary_color: 'ffcb00',
        nav: {
          nav_bg_color: 'ffffff',
          header_bg_color: 'ffffff',
          menu_font_color: '2e3639',
          menu_font_color_active: '1b9db3',
          menu_font_color_hover: 'f07f1b',
          icon_one_color: 'f7e413',
          icon_two_color: 'ff0051',
          icon_bg_color: 'ffffff',
        },
        btn_group: {
          btn1: {
            text: 'Continue to order',
            btn_bg_color: 'ff0059',
            btn_color: 'ffffff',
          },
          btn2: {
            btn2_text: 'Order Now',
            btn2_bg_color: 'ffcb00',
            btn2_color: '2e3639',
          },
        },
      },
      section_1: {
        title_1: 'Professional Solutions for Your',
        title_2: 'Service Needs',
        title_3: 'Premium quality at competitive prices guaranteed.',
        btntext: 'Book Now',
        btnbg_color: 'ffcb00',
        btncolor: '2e3639',
        btnplaceholder: 'Enter Location',
        card_section: [bannerSlider1, bannerSlider2, bannerSlider3, bannerSlider4, bannerSlider5],
      },
      section_2: {
        is_section_enable: true,
        banner: '/assets/img/trustimg-generic.png',
        sub_heading_top: 'About Our Company',
        title: 'Welcome',
        h2color: '0E1017',
        h3color: '0E1017',
        paracolor: '191919',
        mainparagraph:
          'We are committed to delivering exceptional service with attention to detail. Our team of professionals ensures reliable solutions tailored to your specific requirements, backed by years of industry experience and customer-focused approach.',
        card_section_one: [
          { _id: 1, text: 'Services Provided', count: '50+' },
          { _id: 2, text: 'Satisfied Clients', count: '10K+' },
          { _id: 3, text: 'Projects Completed', count: '25K+' },
        ],
        card_section_title: 'Top Rated Service Provider',
        rating: '4.9',
        card_sub_text: '(15k Reviews)',
        card_section_two: [
          {
            _id: 1,
            card_icon: '/assets/icons/support-icon.svg',
            card_sub_heading_top: 'Always Available',
            card_title: '24/7 Support',
            card_paragraph:
              'Our customer service team is available around the clock to address your questions and concerns.',
          },
          {
            _id: 2,
            card_icon: '/assets/icons/quality-icon.svg',
            card_sub_heading_top: 'Trusted Quality',
            card_title: 'Professional Standards',
            card_paragraph:
              'Every project is handled by certified professionals using industry-best practices and equipment.',
          },
          {
            _id: 3,
            card_icon: '/assets/icons/consult-icon.svg',
            card_sub_heading_top: 'Expert Advice',
            card_title: 'Free Consultation',
            card_paragraph:
              'Get personalized recommendations from our experienced team to find the perfect solution for your needs.',
          },
        ],
      },
      section_3: {
        h2color: '0E1017',
        h3color: '0E1017',
        paracolor: '191919',
        cards: [
          {
            bg_img: '/assets/img/service-process-1.jpg',
            card_title: 'Have Special Requirements?',
            card_paragraph:
              'We accommodate all special requests and handle every project with extra care.',
            services: [
              { id: '1', list: 'Standard Services' },
              { id: '2', list: 'Premium Solutions' },
              { id: '3', list: 'Custom Options' },
            ],
            card_main_title: 'We Come To You',
            card_main_paragraph:
              'Our mobile services are available at your home, office, or any preferred location. Flexible scheduling to fit your busy routine.',
            card_options: [
              { id: '1', list: '100% Satisfaction Guarantee' },
              { id: '2', list: 'Competitive Pricing' },
              { id: '3', list: 'Free Estimates' },
              { id: '4', list: 'Quality Assurance' },
            ],
          },
          {
            bg_img: '/assets/img/service-process-2.jpg',
            card_title: 'Easy Scheduling',
            card_paragraph:
              'Book your service through our app, website, or by phone in just minutes.',
            services: [
              { id: '1', list: 'Secure Payments' },
              { id: '2', list: 'Eco-Friendly Methods' },
              { id: '3', list: 'Time & Money Savings' },
            ],
            card_main_title: 'Pre-Service Preparation',
            card_main_paragraph:
              "We'll guide you through simple preparation steps to ensure optimal results. Our team brings all necessary equipment and supplies.",
            card_options: [
              { id: '1', list: 'Transparent Process' },
              { id: '2', list: 'No Hidden Fees' },
              { id: '3', list: 'Flexible Rescheduling' },
              { id: '4', list: 'Professional Equipment' },
            ],
          },
          {
            bg_img: '/assets/img/home/wing3.png',
            card_title: 'Service Scheduled',
            card_paragraph:
              'Book through our website or mobile app to schedule your service effortlessly.',
            services: [
              {
                id: 1,
                list: 'Transparent Pricing',
              },
              {
                id: 2,
                list: 'Top Rated Experts',
              },
            ],
            card_main_title: 'Professional Assigned to Your Task',
            card_main_paragraph:
              "Get real-time updates as our professional prepares to assist you. You'll be notified when they are en route. We ensure a reliable, timely, and eco-conscious experience with quality service providers you can trust.",
            card_options: [
              {
                id: 1,
                list: 'Customer First Approach',
              },
              {
                id: 2,
                list: 'Affordable Services',
              },
              {
                id: 3,
                list: 'Doorstep Convenience',
              },
              {
                id: 4,
                list: 'Reliable Quality',
              },
            ],
          },
          {
            bg_img: '/assets/img/home/wing4.png',
            card_title: 'Service in Progress',
            card_paragraph:
              'Track your service in real-time and stay informed from start to finish.',
            services: [
              {
                id: 1,
                list: 'Quick Turnaround',
              },
              {
                id: 2,
                list: 'Flexible Scheduling',
              },
            ],
            card_main_title: 'We Handle Everything with Care',
            card_main_paragraph:
              'Your task is managed with precision by skilled professionals. Stay updated at every step. Reschedule easily if needed. Enjoy transparent updates, efficient service, and complete peace of mind.',
            card_options: [
              {
                id: 1,
                list: 'Customer First Approach',
              },
              {
                id: 2,
                list: 'Affordable Services',
              },
              {
                id: 3,
                list: 'Doorstep Convenience',
              },
              {
                id: 4,
                list: 'Reliable Quality',
              },
            ],
          },
        ],
      },
      section_5: {
        title: 'Compare Our Services',
        h2color: '0E1017',
        h3color: '0E1017',
        paracolor: '191919',
        cards: [
          {
            card_title: '',
            icon: '/assets/img/icons/serviceicon2.svg',
            card_options: [
              { id: 1, list: 'What is included' },
              { id: 2, list: 'Typical tasks covered' },
              { id: 3, list: 'Estimated duration' },
              { id: 4, list: 'Availability' },
              { id: 5, list: 'Completion details' },
              { id: 6, list: 'Eco friendly' },
            ],
          },
          {
            card_title: 'Standard Package',
            icon: '/assets/img/icons/serviceicon2.svg',
            card_options: [
              { id: 1, list: 'Basic service coverage' },
              { id: 2, list: 'Essential items handled' },
              { id: 3, list: '1–2 hours*' },
              { id: 4, list: 'Available daily' },
              { id: 5, list: 'Completed on-site' },
              { id: 6, list: 'Environment conscious' },
            ],
          },
          {
            card_title: 'Premium Package',
            icon: '/assets/img/icons/serviceicon3.svg',
            card_options: [
              { id: 1, list: 'Extended service features' },
              { id: 2, list: 'Wider scope of tasks' },
              { id: 3, list: '2–4 hours*' },
              { id: 4, list: 'Flexible scheduling' },
              { id: 5, list: 'Thorough completion' },
              { id: 6, list: 'Sustainable approach' },
            ],
          },
          {
            card_title: 'Express Package',
            icon: '/assets/img/icons/serviceicon4.svg',
            card_options: [
              { id: 1, list: 'Quick service option' },
              { id: 2, list: 'Priority handling' },
              { id: 3, list: 'Within 1 hour*' },
              { id: 4, list: 'Same-day available' },
              { id: 5, list: 'Efficient turnaround' },
              { id: 6, list: 'Low environmental impact' },
            ],
          },
        ],
      },
      section_6: {
        collection: [
          {
            collection_title: 'What is your service guarantee policy?',
            collection_paragraph:
              "We stand behind our work with a satisfaction guarantee. If you're not completely happy with our service, we'll make it right at no additional cost.",
          },
          {
            collection_title: 'Do you offer emergency services?',
            collection_paragraph:
              'Yes, we provide 24/7 emergency support for urgent situations with rapid response times.',
          },
        ],
      },
      section_7: {
        title_1: 'Client Feedback',
        title_2: 'What Our Clients Say',
        h2color: '0E1017',
        h3color: '0E1017',
        paracolor: '191919',
        cards: [
          {
            profile: '/assets/img/client1.jpg',
            name: 'Alex Johnson',
            designation: 'Homeowner',
            message:
              'The team was professional, punctual, and did excellent work. I would definitely recommend their services.',
          },
          {
            profile: '/assets/img/client2.jpg',
            name: 'Sarah Williams',
            designation: 'Business Owner',
            message:
              'Reliable service with great attention to detail. They solved my problem quickly and efficiently.',
          },
        ],
      },
      section_9: {
        title: 'Available on Mobile - Download Our App',
        paragraph:
          'Manage all your service needs from your smartphone. Schedule appointments, track progress, make payments, and contact our team - all in one convenient place.',
        android_link:
          'https://play.google.com/store/apps/details?id=com.example.serviceapp',
        ios_link: 'https://apps.apple.com/us/app/service-app/id1234567890',
        banner: '/assets/img/service-app-screenshot.png',
        h2color: '0E1017',
        h3color: '0E1017',
        paracolor: '191919',
      },
      footer: {
        custome_banner_design: { is_enable: true },
        bg_color: '151e2e',
        section_heading_color: 'ffffff',
        section_paragraph_color: 'c2c2c2',
        mbl_number: '+1234567890',
        email_val: 'contact@exampleservice.com',
        address_val: '123 Business Street, City - ST 12345',
        footer_section: {
          about_section: {
            is_enable: true,
            text: 'Professional service solutions tailored to your needs. Contact us today to schedule an appointment or consultation.',
          },
          callnow_for_Services_section: {
            is_enable: true,
            mbl_no: { label: '+1234567890', value: 'tel:+1234567890' },
            email: { label: 'Email Us', value: 'contact@exampleservice.com' },
            address: { text: '123 Business Street, City - ST 12345' },
          },
          social_media: {
            facebook: { is_enable: true, facebook_link: 'facebook.com' },
            instagram: { is_enable: true, instagram_link: 'instagram.com' },
            whatsapp: { is_enable: true, whatsapp_link: 'whatsapp.com' },
          },
        },
      },
    },
  },
  theme_3: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: '/assets/img/section/section1.png',
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: '/assets/img/section/section3.jpg',
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: '/assets/img/section/section4.jpg',
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: '/assets/img/section/section5.jpg',
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: '/assets/img/section/section6.jpg',
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: '/assets/img/section/section7.jpg',
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: '/assets/img/section/section8.jpg',
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: '/assets/img/section/section9.jpg',
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: '/assets/img/section/section10.jpg',
        },
        {
          _id: 11,
          is_section_enable: true,
          icon: '/assets/img/section/section11.jpg',
        },
        {
          _id: 12,
          is_section_enable: true,
          icon: '/assets/img/section/section12.jpg',
        },
        {
          _id: 13,
          is_section_enable: true,
          icon: '/assets/img/section/section13.jpg',
        },
        {
          _id: 15,
          is_section_enable: true,
          icon: '/assets/img/section/section15.jpg',
        },
      ],
      header: {
        is_section_enable: true,
        primary_color: '1B9DB3',
        secondary_color: 'F07F1B',
        nav: {
          bg_color: 'ffffff',
          menu_font_color: '2e3639',
          menu_font_color_active: '1b9db3',
          menu_font_color_hover: 'f07f1b',
          cart_section: {
            is_enable: true,
            bg_color: 'ffffff',
            cart_icon_color: 'ffffff',
            cart_icon_bg_color: 'f07f1b',
            cart_label_section: {
              label: 'items : ',
              color: '6b7385',
            },
            cart_value_color: '000000',
          },
        },
        btn_group: {
          btn1: {
            text: 'Login / Register',
            bg_color: 'ffffff',
            color: '1b9db3',
            border_color: '1b9db3',
            btn1_is_enable: true,
          },
          btn2: {
            text: 'Quick Order',
            color: 'ffffff',
            bg_color: '000',
            border_color: '192335',
            btn2_is_enable: true,
          },
        },
      },
      section_1: {
        is_section_enable: true,
        banner_type: 'image',
        banner: home_page_single_search,
        banner_two: heroimg,
        sub_heading_top: '24/7 Professional Services',
        title: 'Your One-Stop Solution for All Your Needs!',
        paragraph:
          'We pride ourselves on delivering exceptional quality, reliability, and convenience. Our fast and efficient services cater to customers across multiple locations. With cutting-edge technology and state-of-the-art equipment, we ensure superior results at affordable prices.',
        btn_group: {
          btn1: {
            text: 'Book now',
            bg_color: '#1b9db3',
            color: 'ffffff',
            placeholder: 'Enter Postalcode',
            paragraph:
              'We pride ourselves on delivering exceptional quality, reliability, and convenience. Our services cater to customers across multiple locations with advanced technology and equipment.',
            sub_heading_top: '24/7 Professional Services',
            title: 'Your One-Stop Solution for All Your Needs!',
          },
        },
        mobile_link_section: {
          is_enable: true,
          mob_title: 'Just A Click Away',
          android_link: '#',
          ios_link: '#',
          paragraph:
            'We pride ourselves on delivering exceptional quality, reliability, and convenience. Our services cater to customers across multiple locations with advanced technology and equipment.',
          sub_heading_top: '24/7 Professional Services',
          title: 'Your One-Stop Solution for All Your Needs!',
        },
      },
      section_2: {
        is_section_enable: true,
        sub_heading_top: 'Book A Service',
        title: 'Select Your Time & Location For The Service',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        btn_group: {
          btn1: {
            text: 'order now',
            bg_color: '#1b9db3',
            color: 'ffffff',
          },
        },
      },
      section_3: {
        is_section_enable: true,
        sub_heading_top: 'Professional Services',
        title: 'Trust The Experts',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          'Refresh your items with our top-notch services! Our professional team ensures your belongings look and feel their best every time.',
        card_section: {
          btn_group: {
            btn1: {
              text: 'More About Us',
              bg_color: '192335',
              color: 'ffffff',
            },
          },
          collection: [
            {
              _id: 1,
              icon: priorityicon1,
              collection_title: 'Top Quality',
              collection_paragraph:
                'Keep your items in perfect condition with our premium services! Expert care and eco-friendly methods ensure excellent results every time.',
            },
            {
              _id: 2,
              icon: priorityicon2,
              collection_title: 'Best Service',
              collection_paragraph:
                'Effortless solutions at your doorstep! Enjoy professional care and convenient pickup & delivery for all your needs.',
            },
            {
              _id: 3,
              icon: priorityicon3,
              collection_title: 'Great Value',
              collection_paragraph:
                'Enjoy hassle-free solutions with expert care and convenient delivery. Quality service made easy because you deserve the best!',
            },
          ],
        },
      },
      section_4: {
        is_section_enable: true,
        title: 'We are Ranked #1 by customers in our service categories',
        h2color: 'ffffff',
      },
      section_5: {
        is_section_enable: true,
        banner: [{ banner: howwe1 }],
        title: 'We collect, service, and deliver your items',
        paragraph:
          'Say goodbye to hassles! Our expert care and doorstep delivery ensure your items stay in perfect condition - easy, reliable, and convenient!',
        h2color: '2e3639',
        paracolor: '6d7a80',
        check_list: [
          { _id: 1, list: 'Free same day collection' },
          { _id: 2, list: '24h turnaround time' },
          { _id: 3, list: 'Dedicated 24/7 support' },
          { _id: 6, list: 'Free collection and delivery' },
        ],
        btn_group: {
          btn1: {
            text: 'Schedule a Collection Now',
            bg_color: '#192335',
            color: 'ffffff',
            is_enable: true,
          },
          btn2: {
            text: 'Request a Pickup',
            bg_color: '#1b9db3',
            color: 'ffffff',
            is_enable: true,
          },
        },
      },
      section_6: {
        is_section_enable: true,
        sub_heading_top: 'Know More About',
        title: 'How We Work',
        paragraph:
          'We collect, service and deliver your items within 24-48 hrs.',
        h2color: 'ffffff',
        h2subcolor: 'ffffff',
        h3color: '2e3639',
        paracolor: '6d7a80',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: howwe1,
              card_title: 'Online Order',
              card_paragraph:
                'Use our friendly website or app to place your order. Choose a suitable pickup location and time.',
            },
            {
              _id: 2,
              icon: howwe2,
              card_title: 'Transport',
              card_paragraph:
                'Our professional team will pick up your items and transport them safely to our facility.',
            },
            {
              _id: 3,
              icon: howwe3,
              card_title: 'Door Delivery',
              card_paragraph:
                'Finished items are carefully packaged and delivered to your doorstep.',
            },
          ],
          btn_group: {
            btn1: {
              text: 'Book Online Now',
              bg_color: '#192335',
              color: '#ffffff',
            },
          },
        },
      },
      section_7: {
        is_section_enable: true,
        title: 'Our Service Categories',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          'We provide comprehensive services across multiple locations with consistent quality and reliability.',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: laundry,
              card_title: 'Standard Services',
            },
            {
              _id: 2,
              icon: alterations,
              card_title: 'Specialized Solutions',
            },
            {
              _id: 3,
              icon: dryCleaning,
              card_title: 'Premium Care',
            },
          ],
        },
        btn_group: {
          btn1: {
            text: 'Request Service',
            bg_color: '192335',
            color: 'fff',
          },
        },
      },
      section_8: {
        is_section_enable: true,
        title: 'About Us',
        section_image: trustimg2,
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        paragraph:
          'We are synonymous with quality, reliability, and trust. Our advanced technology and modern processes mean affordable solutions for all our customers.',
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: 'Free Pick up and Delivery',
              isEnabled: true,
              collection_paragraph:
                'We offer a convenient way to have items picked up and delivered for free.',
              collection_image: priorityicon7,
            },
            {
              _id: 2,
              collection_title: 'High Quality Services',
              isEnabled: true,
              collection_paragraph:
                'Our team provides perfect care and timely delivery for all your needs.',
              collection_image: priorityicon8,
            },
          ],
        },
      },
      section_9: {
        is_section_enable: true,
        section_bg_color: '#1b9db3',
        sub_heading_top: 'Our Premium Services',
        title: 'On-Demand Professional Services',
        paragraph:
          'We handle, process and deliver your items within 24-48 hours.',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: priorityimg1,
              collection_title: 'Standard Service',
              collection_paragraph:
                'Our professional process includes specialized treatment based on material requirements. All items receive careful finishing to maintain quality and appearance.',
            },
            {
              _id: 2,
              icon: priorityimg2,
              collection_title: 'Premium Service',
              collection_paragraph:
                'Expert handling with customized solutions tailored to specific needs. Includes quality inspection and professional finishing for optimal results.',
            },
            {
              _id: 3,
              icon: priorityimg3,
              collection_title: 'Custom Solutions',
              collection_paragraph:
                'Personalized service options designed for unique requirements. Our specialists ensure proper handling from start to finish.',
            },
          ],
          count_section: [
            {
              _id: 1,
              icon: priorityicon1,
              text: 'Standard Services',
              count: '1600+',
            },
            {
              _id: 2,
              icon: priorityicon2,
              text: 'Premium Services',
              count: '24000+',
            },
            {
              _id: 3,
              icon: priorityicon3,
              text: 'Custom Projects',
              count: '4700+',
            },
            {
              _id: 4,
              icon: priorityicon4,
              text: 'Service Options',
              count: '25+',
            },
          ],
        },
      },
      section_10: {
        is_section_enable: true,
        banner: trustimg3,
        sub_heading_top: 'Your Satisfaction Is Our Priority',
        title: 'Our Values',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        cardcolor: 'ffffff',
        mainparagraph:
          'We maintain strict quality controls and never outsource your items to third parties.',
        list_Section: [
          {
            _id: 1,
            text: 'Contactless service',
            paragraph:
              'For customer safety, we offer completely contactless pickup and delivery options.',
          },
          {
            _id: 2,
            text: 'Instant updates',
            paragraph:
              'We provide real-time notifications throughout the service process.',
          },
        ],
      },
      section_12: {
        is_section_enable: true,
        sub_heading_top: 'What Our Clients Say',
        title: 'A Trusted Service Provider',
        paragraph: 'Read what our customers say about us',
        review_bottom_paragraph:
          'Thousands of positive reviews across multiple platforms',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        review_card: [
          {
            _id: 1,
            reviewer_pic: testimonialuser1,
            reviewer_name: 'Alex Johnson',
            rating: '5',
            review:
              "Best service I've used! My items were handled professionally and delivered back to me quickly. The pickup/drop-off made everything effortless!",
          },
          {
            _id: 2,
            reviewer_pic: testimonialuser2,
            reviewer_name: 'Sarah Williams',
            rating: '5',
            review:
              'Amazing experience! The quality of service exceeded my expectations. The convenience of doorstep service made it even better. Definitely using again!',
          },
        ],
        btn_group: {
          btn1: {
            text: 'Book Online Now',
            bg_color: '#192335',
            color: '#ffffff',
            is_enable: true,
          },
        },
      },
      section_13: {
        is_section_enable: true,
        banner: iPhone11,
        title: 'Just A Click Away',
        paragraph: 'Download Our Mobile App',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '6d7a80',
        check_list: [
          {
            _id: 1,
            icons: priorityicon14,
            title: 'Cashless payments',
          },
          {
            _id: 2,
            icons: priorityicon15,
            title: 'Fast delivery',
          },
          {
            _id: 4,
            icons: priorityicon16,
            title: 'Live chat support',
          },
        ],
        mobile_link_section: {
          is_enable: true,
          android_link:
            'https://play.google.com/store/apps/details?id=com.example.serviceapp',
          ios_link: 'https://apps.apple.com/app/service-app/id1234567890',
        },
      },
      section_14: {
        is_section_enable: true,
        section_bg_color: '#1b9db3',
        title: 'Subscribe to our newsletter for updates and promotions!',
        btn_group: {
          btn1: {
            text: 'Subscribe',
            bg_color: '#192335',
            color: 'ffffff',
          },
        },
      },
      footer: {
        bg_color: '151e2e',
        section_heading_color: 'ffffff',
        section_paragraph_color: 'c2c2c2',
        footer_section: {
          about_section: {
            is_enable: true,
            text: 'Professional solutions available through our convenient mobile app with pickup and delivery services.',
          },
          callnow_for_Services_section: {
            is_enable: true,
            mbl_no: {
              label: '+1234567890',
              value: 'tel:+1234567890',
            },
            address: {
              text: '123 Business Street, City, Country',
            },
          },
          social_media: {
            facebook: { is_enable: true, facebook_link: 'facebook.com' },
            instagram: { is_enable: true, instagram_link: 'instagram.com' },
          },
        },
      },
    },
  },
  theme_4: {
    home: {
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: '/assets/sections-four/service1.png',
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: '/assets/sections-four/service2.png',
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: '/assets/sections-four/service3.png',
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: '/assets/sections-four/service4.png',
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: '/assets/sections-four/service5.png',
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: '/assets/sections-four/service6.png',
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: '/assets/sections-four/service7.png',
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: '/assets/sections-four/service8.png',
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: '/assets/sections-four/service9.png',
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: '/assets/sections-four/service10.png',
        },
        {
          _id: 11,
          is_section_enable: true,
          icon: '/assets/sections-four/service11.png',
        },
        {
          _id: 12,
          is_section_enable: true,
          icon: '/assets/sections-four/service12.png',
        },
      ],
      header: {
        is_section_enable: true,
        primary_color: '046A38',
        secondary_color: '01190D',
        contact: {
          email_id: 'contact@serviceprovider.com',
          contact_number: '+1234567890',
        },
        nav: {
          bg_color: 'ffffff',
          menu_font_color: '2e3639',
          menu_font_color_active: '1b9db3',
          menu_font_color_hover: 'f07f1b',
          cart_section: {
            is_enable: true,
            bg_color: 'ffffff',
            cart_icon_color: 'ffffff',
            cart_icon_bg_color: '#f07f1b',
            cart_label_section: {
              label: 'items : ',
              color: '#6b7385',
            },
            cart_value_color: '000000',
          },
        },
        btn_group: {
          btn1_text: 'Login / Register',
          btn1_bg_color: '046A38',
          btn1_color: 'ffffff',
          btn1_border_color: '046A38',
          btn1_is_enable: true,
          btn2_text: 'Quick Order',
          btn2_color: 'ffffff',
          btn2_bg_color: '000',
          btn2_border_color: '#192335',
          btn2_is_enable: true,
        },
      },
      section_1: {
        is_section_enable: true,
        banner_type: 'image',
        banner: home_page_single_search,
        banner_two: heroimg2,
        sub_heading_top: '24/7 Professional Services',
        title: 'Complete Solutions for Your Needs',
        paragraph: 'Schedule your preferred time and location for service',
        btn_group: {
          btn1: {
            text: 'Order now',
            bg_color: '#046A38',
            color: 'ffffff',
            placeholder: 'Enter Location',
          },
        },
      },
      section_2: {
        is_section_enable: true,
        title: 'Trust Our Professionals',
        paragraph:
          'We combine expertise with quality materials to deliver exceptional results for every client.',
        first_card_image: trustimg1,
        image_title: 'Why thousands of customers choose Us?',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: priorityicon1,
              collection_title: 'Premium Quality',
              collection_paragraph:
                'We use only the best materials and techniques to ensure outstanding results for every project.',
            },
            {
              _id: 2,
              icon: priorityicon4,
              collection_title: 'Professional Standards',
              collection_paragraph:
                'Our team consists of certified professionals who adhere to industry best practices.',
            },
          ],
        },
      },
      section_3: {
        is_section_enable: true,
        title: 'Top Rated Service Provider in the UK',
        banner: reviewBg,
      },
      section_4: {
        is_section_enable: true,
        banner: trustimg2,
        title: 'About Our Company',
        paragraph_one:
          "With years of experience in the industry, we've built a reputation for reliability and excellence.",
        paragraph_two:
          'Our team of professionals is committed to delivering quality services using the latest techniques and equipment.',
        option_one: 'Same-day service available',
        option_two: '24/7 customer support',
        option_three: 'Competitive pricing',
        btn_group: {
          btn1: {
            text: 'Learn More',
            bg_color: '#046A38',
            color: 'ffffff',
            is_enable: true,
          },
        },
      },
      section_5: {
        is_section_enable: true,
        title: 'Our Service Process',
        paragraph: 'Simple, efficient steps to get the job done right',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: howwe1,
              card_title: 'Book Service',
              card_paragraph:
                'Schedule your appointment through our website, app, or by phone.',
            },
            {
              _id: 2,
              icon: howwe2,
              card_title: 'Service Completion',
              card_paragraph:
                'Our professionals handle your project with care and precision.',
            },
          ],
        },
      },
      section_6: {
        is_section_enable: true,
        title: 'Services for Business & Residential',
        paragraph: 'Comprehensive solutions for all your needs',
        first_card_image: trustimg3,
        sub_title: 'Commercial Services',
        sub_title_two: 'Residential Services',
        card_section: {
          collection: [
            { _id: 1, collection_list: 'Restaurants' },
            { _id: 2, collection_list: 'Hotels' },
            { _id: 3, collection_list: 'Office Buildings' },
          ],
        },
        card_section_two: {
          collection: [
            { _id: 1, collection_list: 'Homes' },
            { _id: 2, collection_list: 'Apartments' },
            { _id: 3, collection_list: 'Condos' },
          ],
        },
      },
      section_8: {
        is_section_enable: true,
        part_one: {
          title: 'Our Safety Standards',
          sub_title: 'Health & Safety Protocols',
          section_image: trustimg2,
          paragraph:
            'We follow strict safety guidelines to protect both our clients and team members.',
          card_section: {
            collection: [
              {
                _id: 1,
                collection_title: 'Contactless Service',
                collection_paragraph:
                  'We offer completely contactless service options for your safety.',
              },
              {
                _id: 2,
                collection_title: 'Real-Time Updates',
                collection_paragraph:
                  'Stay informed with notifications throughout the service process.',
              },
            ],
          },
        },
      },
      section_9: {
        is_section_enable: true,
        section_bg_color: '#1b9db3',
        // sub_heading_top: 'Our Premium Services',
        title: 'On-Demand Professional Services',
        paragraph:
          'We handle, process and deliver your items within 24-48 hours.',
        card_section: {
          collection: [
            {
              _id: 1,
              icon: priorityimg1,
              collection_title: 'Standard Service',
              collection_paragraph:
                'Our professional process includes specialized treatment based on material requirements. All items receive careful finishing to maintain quality and appearance.',
            },
            {
              _id: 2,
              icon: priorityimg2,
              collection_title: 'Premium Service',
              collection_paragraph:
                'Expert handling with customized solutions tailored to specific needs. Includes quality inspection and professional finishing for optimal results.',
            },
            {
              _id: 3,
              icon: priorityimg3,
              collection_title: 'Custom Solutions',
              collection_paragraph:
                'Personalized service options designed for unique requirements. Our specialists ensure proper handling from start to finish.',
            },
          ],
        },
      },      
      section_10: {
        is_section_enable: true,
        title: 'Client Testimonials',
        paragraph: 'Hear what our satisfied customers have to say',
        review_card: [
          {
            _id: 1,
            reviewer_pic: trustimg4,
            reviewer_name: 'Alex Johnson',
            rating: '5',
            review:
              'The team was professional, efficient, and delivered excellent results. Highly recommended!',
          },
        ],
      },
      section_11: {
        is_section_enable: true,
        title: 'Easy Mobile Access',
        paragraph: 'Manage all your service needs from our convenient app',
        check_list: [
          {
            _id: 1,
            icons: priorityicon14,
            title: 'Secure Payments',
          },
          {
            _id: 2,
            icons: priorityicon15,
            title: 'Easy Scheduling',
          },
        ],
        banner: just_clickaway,
      },
      footer: {
        bg_color: '046A38',
        section_paragraph_color: 'c2c2c2',
        text: 'Professional services with a commitment to quality and customer satisfaction.',
        social_media: {
          facebook: { is_enable: true, facebook_link: 'facebook.com' },
          instagram: { is_enable: true, instagram_link: 'instagram.com' },
        },
      },
    },
  },
  theme_5: {
    home: {
      header: {
        is_section_enable: true,
        primary_color: '2fa0ea',
        secondary_color: 'efc10b',
        nav: {
          bg_color: '2fa0ea',
          menu_font_color: 'ffffff',
          menu_font_color_active: 'efc10b',
          menu_font_color_hover: 'efc10b',
          cart_section: {
            is_enable: true,
            bg_color: 'ffffff',
            cart_icon_color: 'ffffff',
            cart_icon_bg_color: '#f07f1b',
            cart_label_section: {
              label: 'items : ',
              color: '#6b7385',
            },
            cart_value_color: 'ffffff',
          },
        },
        btn_group: {
          btn1_text: 'Log in',
          btn1_bg_color: 'efc10b',
          btn1_color: 'ffffff',
          btn1_border_color: 'efc10b',
          btn1_is_enable: true,
          btn2_text: 'Sign up',
          btn2_bg_color: 'efc10b',
          btn2_color: 'ffffff',
          btn2_border_color: 'efc10b',
          btn2_is_enable: true,
          btn3_text: 'Quick Order',
          btn3_color: 'ffffff',
          btn3_bg_color: 'efc10b',
          btn3_border_color: 'efc10b',
          btn3_is_enable: true,
        },
      },
      sections: [
        {
          _id: 1,
          is_section_enable: true,
          icon: '/assets/section-five/section_1.png',
        },
        {
          _id: 2,
          is_section_enable: true,
          icon: '/assets/section-five/section_2.png',
        },
        {
          _id: 3,
          is_section_enable: true,
          icon: '/assets/section-five/section_3.png',
        },
        {
          _id: 4,
          is_section_enable: true,
          icon: '/assets/section-five/section_4.png',
        },
        {
          _id: 5,
          is_section_enable: true,
          icon: '/assets/section-five/section_5.png',
        },
        {
          _id: 6,
          is_section_enable: true,
          icon: '/assets/section-five/section_6.png',
        },
        {
          _id: 7,
          is_section_enable: true,
          icon: '/assets/section-five/section_7.png',
        },
        {
          _id: 8,
          is_section_enable: true,
          icon: '/assets/section-five/section_8.png',
        },
        {
          _id: 9,
          is_section_enable: true,
          icon: '/assets/section-five/self_service_section.png',
        },
        {
          _id: 10,
          is_section_enable: true,
          icon: '/assets/section-five/our_service_section.png',
        },
      ],
      section_1: {
        is_section_enable: true,
        banner_type: 'image',
        banner: bannerImg,
        banner_two: bannerImgTwo,
        title: 'Your Trusted Partner for Everyday Services',
        paragraph:
          ' Reliable, professional service tailored to your everyday needs with care, quality, and convenience',
        btn_group: {
          btn1: {
            text: 'Search',
            bg_color: '2fa0ea',
            color: 'ffffff',
            placeholder: 'Enter Postcode',
          },
        },
      },
      section_self_services: {
        is_section_enable: true,
        title: 'Self Services',
        service_title: [
          {
            _id: 1,
            service_list: 'Small Washer - 7 kilo load is £6',
          },
          {
            _id: 2,
            service_list: 'Medium Washer - 12 Kilo load is £8',
          },
          {
            _id: 3,
            service_list: 'Larger Washer - 18 Kilo load is £9.50',
          },
          {
            _id: 4,
            service_list: 'Medium Drier - Max 10 Kilo load is £1 for 8 minutes',
          },
          {
            _id: 5,
            service_list: 'Larger Drier - Max 20 Kilo load is £1 for 6 minutes',
          },
        ],
      },
      section_our_services: {
          is_section_enable: true,
          title: 'Our Services',
          btn_group: {
              btn1: {
                  text: 'See Full Price List',
                  bg_color: '2fa0ea',
                  color: 'ffffff',
              },
          },
          service_section: {
              services: [
                  {
                      _id: 1,
                      service_title: 'SERVICE CATEGORY 1',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Professional service with attention to detail and quality results',
                      service_text: 'STARTING FROM 5.00',
                  },
                  {
                      _id: 2,
                      service_title: 'SERVICE CATEGORY 2',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Expert care and precision for all your needs',
                      service_text: 'STARTING FROM 4.50',
                  },
                  {
                      _id: 3,
                      service_title: 'SERVICE CATEGORY 3',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Comprehensive solutions tailored to your requirements',
                      service_text: 'STARTING FROM 6.00',
                  },
                  {
                      _id: 4,
                      service_title: 'SERVICE CATEGORY 4',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Professional handling with guaranteed satisfaction',
                      service_text: 'STARTING FROM 3.50',
                  },
                  {
                      _id: 5,
                      service_title: 'SERVICE CATEGORY 5',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Specialized care for premium results',
                      service_text: 'STARTING FROM 7.00',
                  },
                  {
                      _id: 6,
                      service_title: 'SERVICE CATEGORY 6',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Custom solutions for unique needs',
                      service_text: 'STARTING FROM 5.00',
                  },
                  {
                      _id: 7,
                      service_title: 'PREMIUM SERVICE',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Exceptional quality with white-glove service',
                      service_text: 'STARTING FROM 10.00',
                  },
                  {
                      _id: 8,
                      service_title: 'BASIC SERVICE',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Affordable solutions without compromising quality',
                      service_text: 'STARTING FROM 3.00',
                  },
                  {
                      _id: 9,
                      service_title: 'SPECIALIZED SERVICE',
                      service_image: ServiceIcon10,
                      isEnabled: true,
                      service_description: 'Expert care for delicate and valuable items',
                      service_text: 'STARTING FROM 8.00',
                  },
              ],
          },
      },
      section_4: {
        is_section_enable: true,
        banner: '/assets/img/offer/offer-vector-bg.png',
        offer_tag: '/assets/img/offer/offer-tag.png',
        picture: '/assets/img/offer/offer-wash-img.png',
        paragraph_one:
          '* Offer applied only to Registered Users (On Selected Shops)',
      },
      section_5: {
        is_section_enable: true,
        banner: washFoldImg,
        banner_two: '',
        title: 'Trusted Service',
        h2color: 'ffffff',
        paracolor: '2e3639',
        wash_title: [
          {
            _id: 1,
            wash_list: 'Fast and reliable',
          },
          {
            _id: 2,
            wash_list: 'Easy to book',
          },
          {
            _id: 3,
            wash_list: 'Quality guaranteed',
          },
          {
            _id: 4,
            wash_list: 'Customer-first approach',
          },
        ],
      },
      section_6: {
        is_section_enable: true,
        title: 'ABOUT Us',
        sub_heading:
          'Delivering Trusted Services with a Focus on Quality and Care',
        section_image: washFoldImg,
        background_image_color: 'efc10b',
        paragraph:
          'We are a service-focused team dedicated to making everyday tasks easier through reliable, professional, and customer-friendly solutions.',
        h2color: 'ffffff',
        h3color: 'ffffff',
        paracolor: 'ffffff',
        card_section: {
          collection: [
            {
              _id: 1,
              collection_title: 'Cost Effective',
              collection_image: aboutIcon1,
              isEnabled: true,
              collection_paragraph:
                'Provides quality service with reasonable prices to all.',
            },
            {
              _id: 2,
              collection_title: 'Simple Solutions',
              collection_image: aboutIcon2,
              isEnabled: true,
              collection_paragraph:
                'Efficient services tailored to your everyday needs.',
            },
            {
              _id: 3,
              collection_title: 'Professional Support',
              collection_image: aboutIcon3,
              isEnabled: true,
              collection_paragraph:
                'Expert help designed to make your life easier.',
            },
            {
              _id: 4,
              collection_title: 'Trusted Team',
              collection_image: aboutIcon4,
              isEnabled: true,
              collection_paragraph:
                'Friendly, skilled professionals focused on quality care.',
            },
          ],
        },
      },
      section_7: {
        is_section_enable: true,
        title: 'Service Made Simple Everyday',
        paragraph1:
          'We make it easy to get the help you need—when you need it. Whether routine tasks or urgent support, our team is here to make things smooth, fast, and worry-free.',
        banner: easyToImg,
        paragraph2:
          'We provide fast, reliable services designed to fit seamlessly into your routine. From start to finish, we focus on quality, convenience, and care.',
        paragraph3:
          'Our team delivers dependable, hassle-free solutions tailored to your needs. We make everyday tasks simple, smooth, and stress-free.',
        paragraph4:
          'We offer professional, on-demand services that save you time and effort. Count on us for quality, speed, and satisfaction.',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '2e3639',
        card_section: [
          {
            _id: 1,
            text: 'Quick Access – Book services effortlessly, anytime',
          },
          {
            _id: 2,
            text: 'Reliable Results – Count on consistent, high-quality work',
          },
          {
            _id: 3,
            text: 'Friendly Team – Approachable experts who listen and deliver',
          },
          {
            _id: 4,
            text: 'Total Convenience – Designed to fit your schedule and needs.',
          },
        ],
      },
      section_8: {
        is_section_enable: true,
        banner: iphone13,
        bg_color: '#FBF2FF',
        placeholder: 'Eg:-  +4407816545718',
        banner_two: '/assets/images/download_app.png',
        title: 'Download the app',
        paragraph:
          'With our award-winning app, your laundry and dry cleaning needs are just a tap away',
        h2color: '2e3639',
        h3color: '2e3639',
        paracolor: '2e3639',
        mobile_link_section: {
          is_enable: true,
          android_link:
            '',
          ios_link:
            '',
        },
      },
      footer: {
        custome_banner_design: {
          is_enable: true,
        },
        bg_color: '2fa0ea',
        section_heading_color: 'ffffff',
        section_paragraph_color: 'c2c2c2',
        site_title_en: '© All rights reserved. ',
        footer_section: {
          we_are_here_section: {
            is_enable: true,
            text: 'WE ARE HERE FOR YOU..',
          },
          needhelp_section: {
            is_enable: true,
            text: 'NEED HELP?',
          },
          policy_section: {
            is_enable: true,
            text: 'OUR POLICY',
          },
          quickconnect_section: {
            is_enable: true,
            text: 'QUICK CONNECT',
          },
          callnow_for_Services_section: {
            is_enable: true,
            address: {
              label: 'address',
              value: '204 High Road, Woodford Green, IG8 9EF',
            },
            mbl_no: {
              is_enable: true,
              label: 'Phone',
              value: '+442086388690',
            },
            email: {
              is_enable: true,
              label: 'Email',
              value: 'sales@bestatservices.com',
            },
            mbl_no_two: {
              is_enable: true,
              label: 'Phone',
              value: '+442086388690',
            },
            email_two: {
              is_enable: true,
              label: 'Email',
              value: 'sales@bestatservices.com',
            },
          },
          social_media: {
            facebook: {
              is_enable: true,
              facebook_link: 'https://www.facebook.com/bestatservicess',
            },
            instagram: {
              is_enable: true,
              instagram_link: 'https://www.instagram.com/bestatservices',
            },
            whatsapp: {
              is_enable: false,
              whatsapp_link: 'whatsapp.com',
            },
            linkedin: {
              is_enable: false,
              linkedin_link: 'linkedin.com',
            },
            youtube: {
              is_enable: false,
              youtube_link: 'youtube.com',
            },
            twitter: {
              is_enable: false,
              twitter_link: 'twitter.com',
            },
          },
          mobile_link_section: {
            is_enable: true,
            android_link:
              '',
            ios_link:
              '',
          },
        },
      },
    },
  },
};
export const data = {
  home: {
    sections: [
      {
        _id: 1,
        is_section_enable: true,
        icon: '/assets/section/section1.jpg',
      },
      {
        _id: 2,
        is_section_enable: true,
        icon: '/assets/section/section2.jpg',
      },
      {
        _id: 3,
        is_section_enable: true,
        icon: '/assets/section/section3.jpg',
      },
      {
        _id: 4,
        is_section_enable: true,
        icon: '/assets/section/section4.jpg',
      },
      {
        _id: 5,
        is_section_enable: true,
        icon: '/assets/section/section5.jpg',
      },
      {
        _id: 6,
        is_section_enable: true,
        icon: '/assets/section/section6.jpg',
      },
      {
        _id: 7,
        is_section_enable: true,
        icon: '/assets/section/section7.jpg',
      },
      {
        _id: 8,
        is_section_enable: true,
        icon: '/assets/section/section8.jpg',
      },
      {
        _id: 9,
        is_section_enable: true,
        icon: '/assets/section/section9.jpg',
      },
      {
        _id: 10,
        is_section_enable: true,
        icon: '/assets/section/section10.jpg',
      },
      {
        _id: 11,
        is_section_enable: true,
        icon: '/assets/section/section11.jpg',
      },
      {
        _id: 12,
        is_section_enable: true,
        icon: '/assets/section/section12.jpg',
      },
      {
        _id: 13,
        is_section_enable: true,
        icon: '/assets/section/section13.jpg',
      },
      {
        _id: 15,
        is_section_enable: true,
        icon: '/assets/section/section15.jpg',
      },
    ],
    header: {
      is_section_enable: true,
      primary_color: '1B9DB3',
      secondary_color: 'F07F1B',
      nav: {
        bg_color: 'ffffff',
        menu_font_color: '2e3639',
        menu_font_color_active: '1b9db3',
        menu_font_color_hover: 'f07f1b',
        cart_section: {
          is_enable: true,
          bg_color: 'ffffff',
          cart_icon_color: 'ffffff',
          cart_icon_bg_color: '#f07f1b',
          cart_label_section: {
            label: 'items : ',
            color: '#6b7385',
          },
          cart_value_color: '000000',
        },
      },
      btn_group: {
        btn1: {
          text: 'Login / Register',
          bg_color: 'ffffff',
          color: '#1b9db3',
          border_color: '#1b9db3',
          btn1_is_enable: true,
        },
        btn2: {
          text: 'Quick Order',
          color: 'ffffff',
          bg_color: '000',
          border_color: '#192335',
          btn2_is_enable: true,
        },
      },
    },
    section_1: {
      is_section_enable: true,
      banner: '/assets/home_page_single_search.jpg',
      sub_heading_top: '24/7 Dry Cleaning & Laundry Service',
      title: 'One Solution for all your Washing Needs',
      paragraph:
        'We are synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.',
      btn_group: {
        btn1: {
          text: 'Book now',
          bg_color: '#1b9db3',
          color: 'ffffff',
          placeholder: 'Enter Postalcode',
        },
      },
      mobile_link_section: {
        is_enable: true,
        mob_title: 'Just A Click Away',
        android_link: '#',
        ios_link: '#',
      },
    },
    section_2: {
      is_section_enable: true,
      sub_heading_top: 'Book A Service',
      title: 'Select Your Time & Location For The Service',
      btn_group: {
        btn1: {
          text: 'order now',
          bg_color: '#1b9db3',
          color: 'ffffff',
          placeholder: 'Enter Postcode',
        },
      },
    },
    section_3: {
      is_section_enable: true,
      title: 'Trust the Experts',
      paragraph:
        'Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC',
      card_section: {
        collection: [
          {
            _id: 1,
            icon: priorityicon1,
            collection_title: 'Top Quality',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 2,
            icon: priorityicon2,
            collection_title: 'Best Service',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 3,
            icon: priorityicon3,
            collection_title: 'Value',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 4,
            icon: priorityicon4,
            collection_title: 'Professionalism',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 5,
            icon: priorityicon5,
            collection_title: 'Convenience',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
          {
            _id: 6,
            icon: priorityicon6,
            collection_title: 'Cleanliness',
            collection_paragraph:
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard, Lorem Ipsum is simply dummy text of the printing",
          },
        ],
        btn_group: {
          btn1: {
            text: 'More About Us',
            bg_color: '192335',
            color: 'ffffff',
          },
        },
      },
    },
    section_4: {
      is_section_enable: true,
      title:
        'We are Ranked #1 by customers in the UK in categories of dry cleaning',
    },
    section_5: {
      is_section_enable: true,
      banner: [
        {
          banner: howwe1,
        },
      ],
      title: 'We collect, clean, & deliver your laundry & dry cleaning.',
      paragraph:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took",
      check_list: [
        {
          _id: 1,
          title: 'Free same day collection',
        },
        {
          _id: 1,
          title: '24h turnaround time',
        },
        {
          _id: 1,
          title: 'Dedicated 24/7 support',
        },
        {
          _id: 1,
          title: 'Standard wash for just £14',
        },
        {
          _id: 1,
          title: "Wash & Fold for items that don't need pressing",
        },
        {
          _id: 1,
          title: 'Free collection and delivery',
        },
      ],
      btn_group: {
        btn1: {
          text: 'Schedule a Collection Now',
          bg_color: '#192335',
          color: 'ffffff',
          is_enable: true,
        },
        btn2: {
          text: 'Request a Pickup',
          bg_color: '#1b9db3',
          color: 'ffffff',
          is_enable: true,
        },
      },
    },
    section_6: {
      is_section_enable: true,
      sub_heading_top: 'Know More On',
      title: 'How We Works',
      paragraph: 'We collect, clean and deliver your clothes within 24-48 hrs.',
      card_section: {
        collection: [
          {
            _id: 1,
            icon: howwe1,
            card_title: 'Online Order',
            card_paragraph:
              'Use our friendly and easy access website or app to place your laundry order. choose a suitable pickup location and time.',
          },
          {
            _id: 2,
            icon: howwe2,
            card_title: 'Transport',
            card_paragraph:
              'Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.',
          },
          {
            _id: 3,
            icon: howwe3,
            card_title: 'Dry Cleaning',
            card_paragraph:
              'Our registered driver will pick up your laundry at your doorstep and transport the laundry safely to one of our many trusted dry cleaning facilities.',
          },
          {
            _id: 4,
            icon: howwe4,
            card_title: 'Door Delivery',
            card_paragraph:
              'Dry and clean clothes were carefully bagged and delivered to your doorstep.',
          },
        ],
        btn_group: {
          paragraph: 'Lorem Ipsum is simply dummy text of the',
          btn1: {
            text: 'Book Online Now',
            bg_color: '#192335',
            color: '#ffffff',
          },
        },
      },
    },
    section_7: {
      is_section_enable: true,
      title: 'On Demand Laundry, Dry Cleaning And Ironing Categories',
      paragraph:
        'We provide commercial laundry, shoe repair, clothing alteration, tailoring and wedding dress fitting services in London, Essex, Kent, Westminster, Chelsea, Dartford, Croydon, Enfield, Basildon, South On Sea, Bromley, Mayfair, Romford and other areas in London.',
      btn_group: {
        btn_paragraph: 'Lorem Ipsum is simply dummy text of the',
        btn1: {
          text: ' Request a Pickup',
          bg_color: '192335',
          color: 'fff',
        },
      },
    },
    section_8: {
      is_section_enable: true,
      banner: 'howwe1',
      title: 'About Us',
      section_image: '/assets/home/trustimg2.jpg',
      paragraph:
        'We are the synonymous with quality, reliability, and trust. We provide fast dry cleaning and laundry services in and around London. Advance online technology and modern process and equipment utilization means affordable cost to all our customers.',
      card_section: {
        collection: [
          {
            _id: 1,
            icon: 'James please use React import aliase',
            collection_title: 'Free Pick up and Delivery',
            collection_image: priorityicon7,
            isEnabled: true,
            collection_paragraph:
              'We offer a convenient way to have laundry picked up and delivered for free.',
          },
          {
            _id: 2,
            icon: 'James please use React import aliase',
            collection_title: 'High Quality of Services',
            collection_image: priorityicon8,
            isEnabled: true,
            collection_paragraph:
              'Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.',
          },
          {
            _id: 3,
            icon: 'James please use React import aliase',
            collection_title: 'Affordable Cost',
            collection_image: priorityicon9,
            isEnabled: true,
            collection_paragraph:
              'We offer affordable prices when compared to the current market.',
          },
        ],
      },
      btn_group: {
        btn1_text: 'Schedule a Collection Now',
        btn1_bg_color: '192335',
        btn1_color: 'ffffff',
        btn2_text: 'Request a Pickup',
        btn2_bg_color: '1b9db3',
        btn2_color: 'ffffff',
      },
    },
    section_9: {
      is_section_enable: true,
      section_bg_color: '#1b9db3',
      sub_heading_top: 'Our Promising Services',
      title: 'On Demand Laundry, Dry Cleaning And Ironing Service',
      paragraph: 'We collect, clean and deliver your clothes within 24-48 hrs.',
      card_section: {
        collection: [
          {
            _id: 1,
            icon: priorityimg1,
            collection_title: 'Laundry',
            collection_paragraph:
              'A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.',
          },
          {
            _id: 2,
            icon: priorityimg2,
            collection_title: 'Dry Cleaning',
            collection_paragraph:
              'A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.',
          },
          {
            _id: 3,
            icon: priorityimg3,
            collection_title: 'Alteration & Repair',
            collection_paragraph:
              'A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.',
          },
          {
            _id: 14,
            icon: priorityimg1,
            collection_title: 'Laundry',
            collection_paragraph:
              'A tender cleaning procedure is done which may include fluff drying process depending on the fabric. All clothes are pressed, and hand finished. Our methods enhance colours and refresh the textiles of the fabrics.',
          },
        ],
        count_section: [
          {
            _id: 1,
            icon: priorityicon1,
            text: 'Laundry Clothes',
            count: '1639+',
          },
          {
            _id: 2,
            icon: priorityicon2,
            text: 'Steam Ironing',
            count: '24359+',
          },
          {
            _id: 3,
            icon: priorityicon3,
            text: 'Dry Cleaning',
            count: '4793+',
          },
          {
            _id: 4,
            icon: priorityicon4,
            text: 'Cleaning programs',
            count: '25+',
          },
        ],
      },
    },
    section_10: {
      is_section_enable: true,
      banner: trustimg3,
      sub_heading_top: 'Your Health & Safety Is Our Priority',
      title: 'Our Values',
      mainparagraph:
        'online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.',
      list_Section: [
        {
          _id: 1,
          text: 'Contactless deliveries',
          paragraph:
            'For our customers safety, we enabled the feature to allow customers to conduct contactless pick up & deliveries.',
        },
        {
          _id: 2,
          text: 'Instant updates',
          paragraph:
            'We’ll keep you posted throughout the process with texts/emails when driver is on their way and order has been cleaned.',
        },
        {
          _id: 3,
          text: 'Monitoring the situation',
          paragraph:
            'We’re keeping up to date with all developments from government to ensure the safety of our customers and staff.',
        },
      ],
      card_section_title: 'We use Eco-friendly Laundry Detergent Sheets.',
      card_section: [
        {
          _id: 1,
          card_bg_color: '192335',
          card_text: 'Vegan',
          card_paragraph:
            'Our vegan-friendly laundry detergent is free from any animal product.',
        },
        {
          _id: 2,
          card_bg_color: 'f07f1b',
          card_text: 'Cruelty Free',
          card_paragraph:
            'We never test on animals – so our Laundry Leaves will always be cruelty-free.',
        },
        {
          _id: 3,
          card_bg_color: '1bb333',
          card_text: 'Eco-Friendly',
          card_paragraph:
            'Free from any harmful chemicals or pollutants and are devoid of harmful toxins.',
        },
      ],
    },
    section_11: {
      is_section_enable: true,
      banner: [
        {
          banner: howwe1,
        },
      ],
      card_section: {
        collection: [
          {
            _id: 1,
            collection_title: 'Free Pick up and Delivery',
            isEnabled: true,
            collection_paragraph:
              'We offer a convenient way to have laundry picked up and delivered for free.',
          },
          {
            _id: 2,
            collection_title: 'High Quality of Services',
            isEnabled: true,
            collection_paragraph:
              'Our laundry team perfectly cleans, iron, fold, pack, and deliver to you on time.',
          },
          {
            _id: 3,
            collection_title: 'Affordable Cost',
            isEnabled: true,
            collection_paragraph:
              'We offer affordable prices when compared to the current market.',
          },
        ],
      },
      sub_heading_top: 'Ask Your Question',
      title: 'Frequently Asked Questions',
      paragraph:
        'online laundry & dry cleaning companies who simply just own the technology and farm the cleaning to other providers with little to no process system checks.',
    },
    section_12: {
      is_section_enable: true,
      banner: 'howwe1',
      sub_heading_top: 'What Our Client Says',
      title: 'A Trusted Laundry And Dry Cleaning Company',
      paragraph: 'Read what our customers say about us',
      review_bottom_paragraph:
        'More than 5,000+ reviews s on TrustPilot, Google, Google Play & App Store',
      review_card: [
        {
          _id: 1,
          reviewer_pic: '/assets/home/testimonialuser1.jpg',
          reviewer_name: 'Ariyan Rusov',
          rating: '5',
          review_highlight: 'Finibus mauris. Aliquam consectetur',
          review:
            'My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.',
        },
        {
          _id: 2,
          reviewer_pic: testimonialuser2,
          reviewer_name: 'Darren Valdez',
          rating: '4',
          review_highlight: 'Finibus mauris. Aliquam consectetur',
          review:
            'My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.',
        },
        {
          _id: 3,
          reviewer_pic: testimonialuser3,
          reviewer_name: 'Elinor Dunn',
          rating: '5',
          review_highlight: 'Finibus mauris. Aliquam consectetur',
          review:
            'My suits came back quickly and felt newer than the day I bought them great that was easy to use,best part they came to pick them up and drop them off for me.',
        },
      ],
      btn_group: {
        btn1: {
          text: 'Book Online Now',
          bg_color: '#192335',
          color: '#ffffff',
          is_enable: true,
        },
      },
    },
    section_13: {
      is_section_enable: true,
      banner: 'howwe1',
      title: 'Just A Click Away',
      paragraph: 'Download Our Best Active Mobile App',
      check_list: [
        {
          _id: 1,
          icons: priorityicon14,
          title: 'Cashless payments',
        },
        {
          _id: 2,
          icons: priorityicon15,
          title: 'Delivery in less then 24 hours',
        },
        {
          _id: 3,
          icons: priorityicon16,
          title: 'Standard wash for just £14',
        },
        {
          _id: 4,
          icons: priorityicon17,
          title: 'In-app live chat support',
        },
      ],
      mobile_link_section: {
        is_enable: true,
        android_link:
          '',
        ios_link:
          '',
      },
    },
    section_14: {
      is_section_enable: true,
      section_bg_color: '#1b9db3',
      title:
        'Subscribe to our newsletter for updates, exclusive promotions and our latest content!',
      btn_group: {
        btn1: {
          text: 'Subscribe',
          bg_color: '#192335',
          color: 'ffffff',
        },
      },
    },
    section_15: {
      is_section_enable: true,
      sub_heading_top: 'Our Latest',
      title: 'News & Events',
      paragraph:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.',
      btn_group: {
        btn1: {
          text: 'More News & Events',
          bg_color: '#192335',
          color: 'ffffff',
        },
      },
    },
    footer: {
      custome_banner_design: {
        is_enable: true,
      },
      bg_color: '151e2e',
      section_heading_color: 'ffffff',
      section_paragraph_color: 'c2c2c2',
      footer_section: {
        about_section: {
          is_enable: true,
          text: 'Ready to take laundry off your to-do list? our services are a local laundry pickup and delivery service that you can order directly from your smart phone.',
        },
        service_section: {
          is_enable: true,
        },
        quicklink_section: {
          is_enable: true,
        },
        callnow_for_Services_section: {
          is_enable: true,
          mbl_no: {
            label: '+442086388690',
            value: 'tel:+442086388690',
          },
          email: {
            label: 'Email Us',
            value: 'sales@bestatservices.com',
          },
          address: {
            text: '81 Randall Drive, Hornchurch - RM126TA',
          },
        },
        social_media: {
          facebook: {
            is_enable: true,
            facebook_link: 'facebook.com',
          },
          instagram: {
            is_enable: true,
            instagram_link: 'instagram.com',
          },
          whatsapp: {
            is_enable: true,
            whatsapp_link: 'whatsapp.com',
          },
          linkedin: {
            is_enable: true,
            linkedin_link: 'linkedin.com',
          },
          youtube: {
            is_enable: true,
            youtube_link: 'youtube.com',
          },
          twitter: {
            is_enable: true,
            twitter_link: 'twitter.com',
          },
        },
      },
    },
  },
};
